const formatLottieAnimation = (src, style, ratio = null) => {
  // if data property exists in JSON object, stringify that property's value, otherwise use the URL supplied.
  const outputSrc = src?.data ? JSON.stringify(src?.data) : src;
  if (!src) {
    return null
  } else {
    return {
      type: "lottieAnimation",
      src: outputSrc,
      style: style,
      ratio: {
        width: ratio?.width,
        height: ratio?.height,
      },
    }
  }
}

export default formatLottieAnimation
